import { Avatar } from "@mui/material";

export function MiAvatar({ children, ...rest }) {
  return <Avatar {...rest}>{children}</Avatar>;
}
